// this would be the main class that renders the game
import Stats from "stats-js";
import SceneManager from "./scene/SceneManager";
import { createEl, appendChildren } from "./utils";
// import Intro from './intro';
import Takeoff from "./takeoff";
import Progress from "./progress";
import Yoke from "./yoke";

import Cockpit from "./cockpit";

// import { randomId } from '../dist/assets/views/00_common/userActions';
// import { userActions } from '../dist/assets/views/00_common/userActions';

function generateRandomId() {
    return "user_" + Math.random().toString(36).substr(2, 11); // You can adjust the length of the random string if needed
}

export default class Airplane {
    constructor(state) {
        this.state = state;

        this.el = createEl("div", { className: "airplane" });
        this.scene = createEl("div", { className: "airplane-scene hidden" });

        this.takeoff = new Takeoff(state);

        this.sceneManager = new SceneManager(this.state, this.scene);
        this.progress = new Progress(this.state);
        this.yoke = new Yoke(this.state, this.sceneManager.parallax);
        this.cockpit = new Cockpit(this.state);

        const el_cockpit_top = createEl("div", {
            className: "airplane-cockpit-top",
        });
        const el_cockpit_top_off = createEl("div", {
            className: "cockpit_lights__top_off",
        });
        const el_cockpit_top_on = createEl("div", {
            className: "cockpit_lights__top_on",
        });
        //const resetBtn = createEl('div', { className: 'reset_btn' });

        // const reset_btn = createEl('button', { className: 'reset_btn' }, {}, { click: () => { this.toggleReset(); } });

        const reset_btn = createEl(
            "button",
            { className: "reset_btn" },
            {},
            {
                click: () => {
                    window.location.reload(); // Обновляет страницу
                },
            }
        );
        // const reset_btn = createEl('button', { className: 'reset_btn' }, {}, {
        //     click: () => {
        //         let randomId = generateRandomId();
        //         //console.log(userActions);
        //         //console.log("-------------------");
        //         var userActions = [];
        //         // Iterate through the userActions array
        //             for (let i = 0; i < userActions.length; i++) {
        //                 const currentItem = userActions[i];

        //                 // Check if the current item includes "Menu_" in its name
        //                 if (currentItem.includes('Menu_')) {
        //                     // Remove the item before the current item, if it exists
        //                     if (i > 0) {
        //                         userActions.splice(i - 1, 1);
        //                         i--; // Decrement i to adjust for the removed item
        //                     }

        //                     // Remove the item after the current item, if it exists and its suffix matches with the suffix of the "Menu_" item
        //                     if (i < userActions.length - 1) {
        //                         const nextItem = userActions[i + 1];
        //                         const menuSuffix = currentItem.substring(currentItem.lastIndexOf('_') + 1);
        //                         const nextSuffix = nextItem.substring(nextItem.lastIndexOf('_') + 1);
        //                         if (nextSuffix === menuSuffix) {
        //                             userActions.splice(i + 1, 1);
        //                         }
        //                     }
        //                 }
        //             }

        //             //console.log(userActions);

        //             // Construct the JSON payload
        //             const payload = {
        //                 user: randomId,
        //                 actions: userActions
        //             };

        //             console.log("Json" + payload);

        //         //************ SEND USER ACTIONS START ****************************************************************************/

        //         const url = 'Home/datasubmit'; // Replace this with your actual endpoint URL

        //                 // Define the options for the fetch request
        //                     const options = {
        //                         method: 'POST', // Use the POST method to send data
        //                         headers: {
        //                             'Content-Type': 'application/json', // Specify that you're sending JSON data
        //                         },
        //                         body: JSON.stringify(payload), // Convert the payload to a JSON string
        //                     };

        //                 // Send the AJAX request
        //                     fetch(url, options)
        //                         .then(response => {
        //                             if (!response.ok) {
        //                                 throw new Error('Network response was not ok');
        //                             }
        //                             // If the response is successful, call toggleReset
        //                             return response.json();
        //                         })
        //                         .then(data => {
        //                             console.log('AJAX request successful:', data);
        //                             // Call toggleReset here
        //                             this.toggleReset();
        //                         })
        //                         .catch(error => {
        //                             console.error('Error:', error);
        //                         });

        //          //************ SEND USER ACTIONS END ****************************************************************************/

        //     }
        // });
        // //const cookie_div = createEl('div', { className: 'cookie_banner' }, {}, { click: () => { this.toggleCookie(); } });

        el_cockpit_top_off.setAttribute("role", "img");
        el_cockpit_top_on.setAttribute("role", "img");
        //resetBtn.setAttribute("role", "img");

        el_cockpit_top_off.setAttribute("aria-label", "Cockpit top: dark");
        el_cockpit_top_on.setAttribute("aria-label", "Cockpit top: light");

        el_cockpit_top.appendChild(el_cockpit_top_on);
        el_cockpit_top.appendChild(el_cockpit_top_off);
        //el_cockpit_top.appendChild(resetBtn);

        appendChildren(this.scene, this.sceneManager.renderer.domElement);
        appendChildren(
            this.el,
            this.takeoff.el,
            this.scene,
            this.sceneManager.tab.el,
            this.cockpit.el,
            el_cockpit_top,
            this.progress.el,
            this.yoke.el,
            reset_btn
        );

        this.stats = new Stats();
        const showStats = new URLSearchParams(window.location.search).has(
            "showstats"
        );
        if (!showStats) this.stats.dom.classList.add("hidden");

        document.addEventListener("keydown", ({ ctrlKey, key }) => {
            if (ctrlKey && key === "m") {
                this.stats.dom.classList[
                    this.stats.dom.classList.contains("hidden")
                        ? "remove"
                        : "add"
                ]("hidden");
            }
        });
        appendChildren(this.el, this.stats.dom);

        this.render = this.render.bind(this);
        this.render();
    }

    render() {
        this.stats.begin();
        this.sceneManager.update();
        this.stats.end();
        requestAnimationFrame(this.render);
    }

    updateFlow(previous, current) {
        if (current === "takeoff") {
            this.cockpit.turnOnMenubutton();
        }
        if (current === "flying") {
            this.scene.classList.remove("hidden");
            this.cockpit.turnOnAllbuttons();
        }
        this.takeoff.update(previous, current);
        this.progress.updateFlow(previous, current);
        this.cockpit.turnOnLights();
    }

    setBeaconsVisible(isVisible) {
        this.sceneManager.slider.setBeaconsVisible(isVisible);
    }

    onViewClose(view) {
        this.sceneManager.slider.onViewClose(view);
    }

    setControlsActive(value) {
        this.sceneManager.mouseControls.setActive(value);
        this.sceneManager.parallax.setActive(value);
    }

    resetBeacons() {
        Object.values(this.sceneManager.slider.beacons).forEach((beacon) => {
            beacon.setCheckmarkVisible(false);
        });
    }

    toggleReset() {
        window.location.reload();
    }
}
